'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mrHubBot = undefined;

var _hubspot = require('hubspot.bender');

var _hubspot2 = _interopRequireDefault(_hubspot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStaticAssetUrl = function getStaticAssetUrl() {
  for (var _len = arguments.length, pathSegments = Array(_len), _key = 0; _key < _len; _key++) {
    pathSegments[_key] = arguments[_key];
  }

  return _hubspot2.default.staticDomainPrefix + '/' + pathSegments.join('/');
};

var fromSalesImages = getStaticAssetUrl.bind(null, 'salesImages/static-1.389/messages');

var mrHubBot = exports.mrHubBot = fromSalesImages('bot-avatar.svg');


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-messages/static-1.640/js/constants/images.js
// module id = 1017
// module chunks = 2 3